import { API_URL } from '../config/env';

function authHeaders(extra = {}) {
  return { Authorization: `Bearer ${localStorage.getItem('token')}`, ...extra };
}

export async function fetchFamilyById(familyId) {
  const res = await fetch(`${API_URL}/api/families/${familyId}`, {
    headers: authHeaders()
  });
  if (!res.ok) throw new Error('Failed to load family');
  return res.json();
}

export async function fetchStudentsForFamily(familyId, { status = 'all', size = 200 } = {}) {
  const q = new URLSearchParams({
    family_id: String(familyId),
    status,
    size: String(size),
    page: '1',
    sort: 'last_name',
    dir: 'asc'
  });
  const res = await fetch(`${API_URL}/api/students?${q}`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Failed to load students');
  const data = await res.json();
  return Array.isArray(data) ? data : data?.data || [];
}

export async function fetchStudentById(studentId) {
  const res = await fetch(`${API_URL}/api/students/${studentId}`, {
    headers: authHeaders()
  });
  if (!res.ok) throw new Error('Failed to load student');
  return res.json();
}

export async function fetchStudentVoucherHistory(studentId) {
  const res = await fetch(`${API_URL}/api/students/${studentId}/vouchers`, {
    headers: authHeaders()
  });
  if (!res.ok) throw new Error('Failed to load voucher history');
  return res.json();
}
